import React, { useEffect, useState } from "react";
import orderApi from "../../../services/apiServices/orderApi"; // Replace with your API service
import { setLoading } from "../../../services/redux/loadingSlice";
import { useDispatch } from "react-redux";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import "./OrdersListPage.css";
import configService from "../../../services/configService";
import Pagination from "../../../components/common/Pagination/Pagination";
import EyeIcon from "../../../components/icons/EyeIcon";
import { useNavigate } from "react-router-dom";
const OrdersListPage = () => {
    const navigate = useNavigate();
    
    const [page, setPage] = useState(1);
    const [orders, setOrders] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalOrders, setTotalOrders] = useState(0);
    const [error, setError] = useState(null);
    const quantity = configService.getDefaultNumberOfItemsTableClient(); 
    const dispatch = useDispatch();
    const orderBy = "Created:Desc";

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                dispatch(setLoading(true));
                const response = await orderApi.getOrdersPaginated({ page, quantity, orderBy, include: 'Customer.User' });
                setTotalPages(response.TotalPages);
                setTotalOrders(response.TotalCount);
                setOrders(response.Results);
            } catch (err) {
                console.error("Error fetching orders:", err);
                setError("Erro ao carregar pedidos. Tente novamente.");
            } finally {
                dispatch(setLoading(false));
            }
        };

        fetchOrders();
    }, [dispatch, page, quantity, orderBy]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const isExpired = (expirationDate) => {
        return new Date(expirationDate) < new Date();
    };

    const paymentAvailable = (order) => {
        return order.OrderStatusId === 0 && order.LinkCode !== null;
    };

    if (error) {
        return <p className="orders-list-error-message">{error}</p>;
    }

    return (
        <div className="orders-list-page-container">
            <PageTitle title="Selecione a solicitação de compra" />
            <table className="orders-list-table small-font">
                <thead>
                    <tr>
                        <th>Pedido</th>
                        <th>Data</th>
                        <th>Qt.</th>
                        <th>Valor</th>
                        <th>Situação</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order) => (
                        <tr key={order.NrOrder} onClick={() => navigate(
                        paymentAvailable(order) || order.OrderStatusId === 1
                            ? '/pedido/resultado/' + order.NrOrder
                            : '/pedido/' + order.NrOrder
                        )}>
                            <td>{order.NrOrder}</td>
                            <td>
                                {new Date(order.Updated).toLocaleDateString()}{" "}
                                {new Date(order.Updated).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                })}
                            </td>
                            <td>{JSON.parse(order.StItems).length} itens</td>
                            <td>R$ {order.VlnetPrice.toFixed(2).replace(".", ",")}</td>
                            <td>
                                <span
                                    className={`orders-list-status-label ${
                                        order.OrderStatusId === 1
                                            ? "orders-list-status-paid"
                                            : (
                                            isExpired(order.ExpirationDate) ?
                                            'orders-list-status-expired'
                                            : "orders-list-status-pending")
                                    }`}
                                >
                                    {order.OrderStatusId === 1 ? "Pago" :(isExpired(order.ExpirationDate) ? 'Expirado' : "Pendente")}
                                </span>
                            </td>
                            <td className="link clickable">
                                <EyeIcon/>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <sub className="margin-top-default">Total de Pedidos: {totalOrders}</sub>
            <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    );
};

export default OrdersListPage;
